import { gql } from 'src/generated/gql';

export const GET_ID_VERIFICATIONS = gql(`
    query GetIdVerifications($patientId: String!) {
      staff_idVerifications(patientId: $patientId) {
        id
        patientId
        title
        valid
        invalidReason
        missingReason
        notes
        createdAt
        updatedAt
        updatedBy
        imageIds
      }
    }
  `);
